module.exports = __webpack_public_path__ + "img/cross sell Up Vacanta.47df20aa.jpeg";